import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  data: any;
  tmp: any = {};
  private storage = window.localStorage;
  private STORE_KEY = 'key_distriV2';
  constructor() {
    this.load().then(d => {
      console.log('Data', d);
    }).catch(err => {
      console.log('Error', err);
    });
  }

  get currentUser() {
    this.load();
    return this.data.user;
  }
  get currentLogin() {
    let us = this.currentUser;
    return (us && us.login) || "";
  }
  get currentNomPDG() {
    let us = this.currentUser;
    return (us && us.nomPdg) || "";
  }
  get currentRole() {
    let us = this.currentUser;
    return (us && us.role) || "";
  }
  get currentProfil() {
    let us = this.currentUser;
    return (us && us.profil) || '';
  }
  get isUserPartenaire() {
    return this.currentRole === 'PARTENAIRE';
  }

  load() {
    if (this.data) {
      return Promise.resolve(this.data);
    }
    const value = this.getItem(this.STORE_KEY);
    console.log('value store: ', value);
    if (value) {
      this.data = value;
      return Promise.resolve(this.data);
    } else {
      return Promise.resolve(this.setAll({}));
    }
  }

  logOut() {
    this.merge({
      user: null,
      accessToken: null,
      login: null
    });
  }

  merge(settings: any) {
    for (const k of Object.keys(settings)) {
      this.data[k] = settings[k];
    }
    return this.save();
  }

  setValue(key: string, value: any) {
    this.data[key] = value;
    this.setItem(this.STORE_KEY, this.data);
    return value;
  }

  setAll(value: any) {
    this.setItem(this.STORE_KEY, value);
    return value;
  }

  getValue(key: string) {
    const data = this.getItem(this.STORE_KEY);
    return data[key];
  }

  getItem(key) {
    return JSON.parse(this.storage.getItem(key));
  }
  setItem(key, value) {
    this.storage.setItem(key, JSON.stringify(value));
  }
  save() {
    return this.setAll(this.data);
  }

  get allSettings() {
    return this.data;
  }
}
